<template>
  <div class="special-h">
    <div class="img-and-content-container">
      <div class="img-and-content-inner">
        <h2 class="title">{{ $dt(eleConfig, 'title') }}</h2>
        <h2 class="content">{{ $dt(eleConfig, 'content') }}</h2>
      </div>
    </div>
    <div class="img-box">
      <img :src="imgSrc">
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialH",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
.special-h {
  width: 100%;
  position: relative;

  .img-box {
    width: 100%;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;

    .title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 45px;
      color: #003C82;
    }

    .content {
      white-space: pre-wrap;
      font-size: 20px;
      font-weight: 600;
      color: #003C82;
      line-height: 28px;
    }
  }
}
</style>
